import { render, staticRenderFns } from "./MealsTakenChart.vue?vue&type=template&id=f14a4b80"
import script from "./MealsTakenChart.vue?vue&type=script&lang=js"
export * from "./MealsTakenChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports